import api from "../../api"
import { adapterSocialMedia } from "../../utils"
import organizationAdapter from "../organizations/adapter"
import programAdapter from "../programs/adapter"
import eventAdapter from "../events/adapter"
import resourceAdapter from "../resources/adapter"
import blogAdapter from "../blogs/adapter"


const adapter = {
  payloadToOrganizationList(payload){
    let result = []

    if(payload && payload.myOrganizations && payload.myOrganizations.length > 0){
      for (let index = 0; index < payload.myOrganizations.length; index++) {
        const element = payload.myOrganizations[index];
        if(element.organisasi){
          result.push({
            id: element.organisasi.organisasiId,
            name: element.organisasi.namaOrganisasi
          })
        }
      }
    }

    return result
  },
  payloadToProfilePage(payload){
    let result = {}

    const generateOrganization = (organizations) => {
      let result = ''
      for (let index = 0; index < organizations.length; index++) {
        const element = organizations[index];
        if(element.organisasi && element.organisasi.namaOrganisasi){
          result += element.organisasi.namaOrganisasi

          if(index < organizations.length - 1){
            result += ', '
          }
        }
      }
      return result
    }

    if(payload){
      const {
        imgFotoProfile,
        namaIndividu,
        email,
        sosialMedia,
        institusi,
        tentangSaya,
        myOrganizations = [],
        pekerjaan
      } = payload

      const organization = myOrganizations.length === 0 ? undefined : generateOrganization(myOrganizations)

      result = {
        image: api.base_image+imgFotoProfile,
        name: namaIndividu,
        city: undefined,
        email: email,
        socialLinks: adapterSocialMedia.APIToForm(sosialMedia, {}),
        institution: institusi,
        content: tentangSaya,
        organization,
        isMember: myOrganizations.length > 0,
        occupation: {
          id: pekerjaan?.nama[0],
          en: pekerjaan?.nama[1]
        }
      }
    }

    return result
  },
  responseBodyToBookmark(input){
    let output = {
      organizations: [],
      programs: [],
      events: [],
      resources: [],
      blogs: []
    }

    if(input){
      const {
        myBookmark
      } = input

      if(myBookmark){
        const {
          organisasi = [],
          programs = [],
          events = [],
          resources = [],
          blogs = []
        } = myBookmark

        output = {
          organizations: organisasi.map(o => organizationAdapter.responseBodyToRender(o)),
          programs: programAdapter.responseBodyToRender(programs),
          events: eventAdapter.responseBodyToRender(events),
          resources: resourceAdapter.responseBodyToRender(resources),
          blogs: blogAdapter.responseBodyToRender(blogs)
        }
      }

    }

    return output
  }
}

export default adapter
